import {TravelMarker} from "@/model/TravelMarker";

export default {
  data() {
    return {
      origin: null,
      travelMethod: 'driving',
      currentBounds: null,
      travelMark: TravelMarker,
      padding: {top: 100, left: 100, right: 300, bottom: 100},
      route: null
    }
  },
  watch: {
    route: function (val, oldVal) {
      if (val) {
        this.setIcons(val.legs[0].steps);
      }
    },
  },
  methods: {
    getDirection: function (coord, method, reverse, marker) {
      if (window.innerWidth < 600) {
        this.padding = {top: 5, left: 50, right: 50, bottom: 5};
      }
      this.removeTravelMarker();
      this.route = null;
      let end;
      let origin;

      if (reverse) {
        end = [this.origin.lng, this.origin.lat];
        origin = coord;
      } else {
        end = coord;
        origin = [this.origin.lng, this.origin.lat];
      }

      if (method) {
        this.travelMethod = method
      }

      const url =
        'https://api.mapbox.com/directions/v5/mapbox/' +
        this.travelMethod + '/' + origin[0] + ',' +
        origin[1] + ';' + end[0] + ',' + end[1] +
        '?steps=true&geometries=geojson&access_token=' + mapboxgl.accessToken;
      fetch(url).then((res) => {
        if (res.status === 200) {
          return res.json();
        }
      }).then(res => {
        const routeInfo = JSON.parse(JSON.stringify(res.routes[0]));
        routeInfo['method'] = this.travelMethod;
        routeInfo['glink'] = 'https://www.google.com/maps/dir/?api=1&origin='
          + origin[0] + ',' + origin[1] + '&destination=' + end[1] + ',' + end[0];
        this.$store.commit("setRouteInfo", routeInfo);
        const routeData = res.routes[0].geometry.coordinates;
        this.route = routeInfo;
        const geojson = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                properties: {},
                coordinates: routeData
              }
            }
          ]
        };

        if (this.map.getSource('LineString')) {
          this.map.removeLayer('LineString');
          this.map.removeSource('LineString');
        }

        this.map.addSource('LineString', {
          type: 'geojson',
          data: geojson
        });

        this.map.addLayer({
          id: 'LineString',
          type: 'line',
          source: 'LineString',
          layout: {
            'line-join': 'round',
            'line-cap': 'round'
          },
          paint: {
            'line-color': '#406750',
            'line-width': 5
          }
        });

        const routeBounds = new mapboxgl.LngLatBounds();
        this.currentBounds = routeBounds;

        routeData.forEach(coordinate => {
          routeBounds.extend(new mapboxgl.LngLat(coordinate[0], coordinate[1]));
        });

        if (marker) {
          let start = [routeData[0][0], routeData[0][1]];
          let end = [routeData[routeData.length - 1][0], routeData[routeData.length - 1][1]];
          if (reverse) {
            start = [routeData[routeData.length - 1][0], routeData[routeData.length - 1][1]];
            end = [routeData[0][0], routeData[0][1]];
          }
          this.travelMark.features[0].geometry.coordinates = start;
          this.travelMark.features[1].geometry.coordinates = end;
          this.addTravelMarker();
        }

        this.map.fitBounds(routeBounds, {
          padding: this.padding
        });
      }).catch((err) => {
        return err;
      });
    },

    removeDirection: function () {
      this.removeTravelMarker();
      this.route = null;

      if (this.map.getSource('LineString')) {
        this.map.removeLayer('LineString');
        this.map.removeSource('LineString');
      }

      if (this.lotBounds) {
        this.map.fitBounds(this.lotBounds, {
          padding: this.padding,
        });
      }
    },

    removeTravelMarker: function () {
      if (this.map.getSource('travelMarker')) {
        this.map.removeLayer('markerlayer');
        this.map.removeSource('travelMarker');
      }
    },

    addTravelMarker: function () {
      this.map.addSource('travelMarker', {
        type: 'geojson',
        data: this.travelMark
      });

      this.map.addLayer({
        id: 'markerlayer',
        type: 'circle',
        source: 'travelMarker',
        paint: {
          'circle-radius': 8,
          'circle-color': ['get', 'color'],
          'circle-opacity': 0.8
        },
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/map/Direction.js